var map = {
	"./": 470,
	"./development": 1413,
	"./development.js": 1413,
	"./index": 470,
	"./index.js": 470,
	"./preprod": 1414,
	"./preprod.js": 1414,
	"./production": 1393,
	"./production.js": 1393,
	"./staging": 1415,
	"./staging.js": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3442;